export const AdTypeOptions = {
  ALL_SAVED: 'All Saved',
  ONLY_TEMPLATES: 'Only Templates',
}
export type AdTypeOption = (typeof AdTypeOptions)[keyof typeof AdTypeOptions]

export const BoardAdTypeOptions = {
  ALL_SAVED: 'View All Saved',
  ONLY_TEMPLATES: 'View Your Templates',
}
export type BoardAdTypeOption = (typeof BoardAdTypeOptions)[keyof typeof BoardAdTypeOptions]
